import { __rest } from "tslib";
import React from 'react';
import WixStyleReactProvider from '../WixStyleReactProvider';
/** WixDesignSystemProvider */
const WixDesignSystemProvider = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return React.createElement(WixStyleReactProvider, Object.assign({}, rest), children);
};
WixDesignSystemProvider.displayName = 'WixDesignSystemProvider';
export default WixDesignSystemProvider;
//# sourceMappingURL=WixDesignSystemProvider.js.map